import appDependency from '../../scripts/appDependency.js';

import '../_common/default-button/defaultButton.module.js';

appDependency.addItem('defaultButton');

import './search.js';
import './controllers/searchBlockController.js';
